import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import clsx from "clsx";
import Draggable from "react-draggable";

const Wrap = styled("div")(({ theme }) => ({
  "& .MuiBackdrop-root": {
    backgroundColor: "rgba(0, 0, 0, 0.2)",
  },
}));

const Title = styled(DialogTitle)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: "#fff",
  textTransform: "uppercase",
  fontSize: "1rem",
}));

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  minWidth: 350,
  paddingLeft: 0,
  paddingRight: 0,
  "& p": {
    marginBottom: "0.5em",
  },
}));

const CloseButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  right: theme.spacing(1),
  top: theme.spacing(0.5),
  color: theme.palette.grey[500], // replaced from theme.card.bg (non-standard in MUI v5)
}));

const Content = styled("div")(({ theme }) => ({
  padding: `${theme.spacing(1)} ${theme.spacing(3)} 0 ${theme.spacing(3)}`,
}));

const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  "& button": {
    "& svg": {
      marginRight: theme.spacing(1),
    },
  },
}));

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

export default function DraggableDialog(props) {
  const {
    open = true,
    actions,
    children,
    title = "AMS",
    draggable = true,
    toolbar = true,
    maxWidth = "md",
    scroll = "paper",
    className,
    height = "auto",
    fullScreen = false,
    fullWidth = false,
    onClose,
  } = props;

  return (
    <Wrap className={clsx(className)}>
      <Dialog
        open={open}
        PaperComponent={PaperComponent}
        maxWidth={maxWidth}
        scroll={scroll}
        fullWidth={fullWidth}
        fullScreen={fullScreen}
      >
        {draggable && toolbar && (
          <Title id="draggable-dialog-title">{title}</Title>
        )}
        {!draggable && <Title>{title}</Title>}
        <StyledDialogContent dividers style={{ height }}>
          <Content>{children}</Content>
        </StyledDialogContent>
        {Boolean(actions) && (
          <StyledDialogActions>{actions}</StyledDialogActions>
        )}
        {Boolean(onClose) && (
          <CloseButton aria-label="close" onClick={onClose}>
            <CloseIcon />
          </CloseButton>
        )}
      </Dialog>
    </Wrap>
  );
}
